"use client";

import { useCallback, useEffect, useState } from "react";
import {
  isPartyPassUpsellExpandRequested,
  isPartyPassUpsellExpanded,
  setPartyPassUpsellExpanded,
} from "../party-pass-upsell";

export interface UsePartyPassUpsellExpandedResult {
  expanded: boolean;
  toggle: () => void;
}

export function usePartyPassUpsellExpanded(
  partyId: string,
  forceExpanded = false,
): UsePartyPassUpsellExpandedResult {
  const [expanded, setExpanded] = useState(forceExpanded);

  useEffect(() => {
    if (
      forceExpanded ||
      isPartyPassUpsellExpandRequested(window.location.hash)
    ) {
      setExpanded(true);
      return;
    }

    setExpanded(isPartyPassUpsellExpanded(window.localStorage, partyId));
  }, [partyId, forceExpanded]);

  const toggle = useCallback(() => {
    const normalized = partyId.trim();
    if (!normalized) {
      return;
    }

    setExpanded((current) => {
      const next = !current;
      setPartyPassUpsellExpanded(window.localStorage, normalized, next);
      return next;
    });
  }, [partyId]);

  return { expanded, toggle };
}
